<template lang="pug">
.vue-recaptcha
  vue-recaptcha(
    v-if="sitekey"
    ref="recaptcha"
    size="invisible"
    :badge="badge"
    :loadRecaptchaScript="true"
    :sitekey="sitekey"
    @error="onError"
    @expired="onExpired"
    @verify="onVerify"
  )
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
  components: {VueRecaptcha},

  props: {
    badge: String,
    sitekey: String,
  },

  data() {
    return {
      response: null,
    }
  },

  methods: {
    execute() {
      if(this.sitekey && this.response == null) {
        this.$refs.recaptcha.execute()
      }
      else {
        this.$emit('verify', this.response)
      }
    },

    reset() {
      if(this.sitekey) {
        this.$refs.recaptcha.reset()
        this.response = null
      }
    },

    onError(e) {
      console.log('vue-recaptcha-ex: onRecaptchaError', e)
      this.$emit('error', e)
    },

    onExpired() {
      this.response = null
    },

    onVerify(response) {
      this.response = {'g-recaptcha-response': response}
      this.$emit('verify', this.response)
    },
  },
}
</script>

<style lang="sass">
.grecaptcha-badge
  z-index: 2147483647
</style>
